import { IconWorldWww } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import IconButton from '../../components/Buttons/IconButton';
import TableComponent from '../../components/DataTable/TableComponent';
import TableImage from '../../components/ImageComponent/TableImage';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import IngestSiteModal from './Components/IngestSiteModal';
import { Badge } from 'react-bootstrap';
import PromptResponse from '../Users/Components/PromptResponse';
import AddPromptResponse from '../Users/Components/AddPromptResponse';
import CreateTemplateModal from './Components/CreateTamplateModel';

const UserOrgList = () => {
    const { userId } = useParams();
    const [userDetails, setUserDetails] = useState({});
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    })

    const getUserDetails = async () => {
        loadingShow();
        let resp = await getApi(urlApi.useDetailsById + userId);
        loadingHide();
        if (resp.responseCode === 200) {
            setUserDetails(resp.data);
        } else {
            setUserDetails({});
        }
    }

    useEffect(() => {
        getUserDetails();
        getTableData();
        return () => { }
    }, [userId]);

    async function getTableData() {
        loadingShow();
        let url = `${urlApi.getOrgListOfUser}${userId}`;
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data,
                totalCount: resp.data?.length
            })
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
            toast.error(resp.message);
        }
    }

    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (index + 1) },
        {
            name: "Name", center: "true", selector: (row) => row?.name, cell: (row) => (

                <div className='flex items-center gap-2 py-2'>
                    {row?.icon != null && <TableImage imageUrl={row?.icon} altText={row?.name} />}
                    <div className='text-center'>
                        <p className='fw-bold'>{row?.name}</p>
                        {userDetails?.defaultOrganizationId == row?.orgId && <Badge>Selected</Badge>}
                    </div>
                </div>
            ),
        },
        { name: "Role", center: "true", selector: (row) => row?.role, cell: (row) => (<p className="mb-0.5 font-semibold text-sm text-primary py-3">{row?.role == 1 ? "Admin" : "Member"}</p>), },

        {
            name: "Action", center: "true", selector: (row) => row?.action, cell: (row) =>
                <div className='flex flex-wrap gap-2 items-center justify-center'>
                    <IngestSiteModal orgData={row} buttonComponent={<IconButton icon={< IconWorldWww size={16} />} text={"Ingest Site"} />} />
                    <PromptResponse orgID={row?.orgId} orgName={row?.name} />
                    <AddPromptResponse orgID={row?.orgId} callback={() => getTableData()} orgName={row?.name} />
                    <CreateTemplateModal orgID={row?.orgId} callback={() => getTableData()} orgName={row?.name} />

                </div>

        },
    ];

    return (
        <Layout>
            <div className="flex flex-wrap !gap-6 items-center justify-center mb-2">
                <img src={userDetails?.profilePic} alt="" className='h-32 aspect-square rounded-md object-contain' />
                <div>
                    <p className='text-sm text-gray-600'>Name : <span className='font-medium'>{userDetails.name}</span> </p>
                    <p className='text-sm text-gray-600'>Email : <span className='font-medium'>{userDetails.email ?? "--"}</span></p>
                    <p className='text-sm text-gray-600'>Phone :  <span className='font-medium'>{userDetails.phone}</span></p>
                </div>
            </div>

            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={true}
                handlePageChange={(e) => { }}
                handlePerRowsChange={(newPerPage, page) => { }} />
        </Layout>
    )
}

export default UserOrgList